const handleLinkClick = (e: MouseEvent) => {
  e.preventDefault();
  const currentTarget = e.currentTarget as HTMLAnchorElement;
  const submenu = currentTarget.nextElementSibling;

  submenu.classList.toggle('active');
};

const init = (menuItem: HTMLElement) => {
  const menuLink = menuItem.querySelector<HTMLAnchorElement>(
    ':scope > .minimenu__link',
  );

  menuLink.addEventListener('click', (e: MouseEvent) => handleLinkClick(e));
};

export default init;
